import { render, staticRenderFns } from "./Data-B2b.vue?vue&type=template&id=dcb97b38"
import script from "./Data-B2b.vue?vue&type=script&lang=js"
export * from "./Data-B2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports